import { createAction, props } from '@ngrx/store';

import type { SalesYear } from '../../shared/models/sales-year.type';

export const loadSalesYears = createAction('[Global] Load Sales Years');
export const loadSalesYearsSuccess = createAction(
  '[Global] Load Sales Years Success',
  props<{ salesYears: SalesYear[] }>()
);
export const loadSalesYearsFail = createAction('[Global] Load Sales Years Fail', props<{ error: Error }>());

export const changeSalesYear = createAction('[Global] Change Sales Year', props<{ newSalesYear: SalesYear }>());
export const changeSalesYearSuccess = createAction('[Global] Change Sales Year Success');
